<template>
  <div>
    <el-row>
      <el-form class="searchForm" ref="form" :model="findData" label-width="90px" style="margin-top: 20px">
        <el-col :md="10" :lg="10" :xl="8">
          <el-form-item label="申请时间">
            <el-date-picker style="width: 100%" type="daterange" :default-time="['00:00:00', '23:59:59']" start-placeholder="开始日期" end-placeholder="结束日期" v-model="findData.timeRange" format="yyyy年MM月dd日" value-format="yyyy-MM-dd H:m:s"></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :md="10" :lg="10" :xl="8">
          <el-form-item label="稿件标题">
            <el-input placeholder="模糊检索" v-model="findData.title"></el-input>
          </el-form-item>
        </el-col>

        <el-col :md="4" :lg="4" :xl="4">
          <div style="margin-left:10px;">
            <el-button type="primary" @click="loadData">搜索</el-button>
          </div>
        </el-col>
      </el-form>
    </el-row>
    <div style="padding: 20px 0">
        <el-button type="warning" :disabled="!flag" @click="auditAll">批量同意退款</el-button>
        <el-button type="primary" :disabled="!flag" @click="exportXLS">导出记录</el-button>
      </div>
    <el-row>
        <el-col :span="24">
          <el-table ref="tableData" :data="tableData" @select-all="selAll" @selection-change="selChange" stripe style="width: 100%">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column type="index" width="40" align="center"> </el-table-column>

            <el-table-column prop="createTime" align="center" label="申请时间" width="120">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>

            <el-table-column prop="title" label="文章"></el-table-column>
            <el-table-column prop="authorName" label="作者"></el-table-column>
            <el-table-column prop="contactTelephone" label="联系电话"></el-table-column>
            <el-table-column prop="payAmount" label="原支付金额"></el-table-column>
          <el-table-column prop="deductAmount" label="扣款金额（查重检测费）"></el-table-column>
          <el-table-column prop="refundAmount" label="申请退款金额"></el-table-column>
            <el-table-column prop="status" label="处理状态">
              <template slot-scope="scope">
                <el-tag type="primary" v-if="scope.row.status == 1">待处理</el-tag>
                <el-tag type="success" v-else-if="scope.row.status == 2">已同意</el-tag>
                <el-tag type="success" v-else-if="scope.row.status == 3">拒绝退款</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="audit_time" label="操作时间">
              <template slot-scope="scope">
                {{ scope.row.auditTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>

          </el-table>
        </el-col>
      </el-row>

      <el-row style="margin-top: 20px">
        <el-pagination background layout="total,sizes,prev, pager, next,jumper" 
        :page-sizes="[10,20,30,50,100]"
        :page-size="pageSize" :total="total" 
        @size-change="pageSizeChange"
        @current-change="pageChange" @prev-click="pagePrev" @next-click="pageNext" style="float: right"> </el-pagination>
      </el-row>
  </div>
</template>

<script>
import refundApi from "@/api/refund"
import financeApi from "@/api/finance"
import attachUtil from "@/utils/attachUtil"
export default {
  components: { },
  data() {
    return {
      curPage: 1,
      tableData: [],
      total: 0,
      pageSize: 10,

      findData:{
        timeRange: "",
        author: "",
        title: "",
        status: 3,
        statusResult:0,
      },
      flag:false,
    }
  },
  mounted() {
    this.loadData()
  },

  methods: {
    //加载数据
    loadData() {
      refundApi.getList(this.curPage,this.pageSize,this.findData).then((res) => {
        this.total = res.total
        this.tableData = res.rows
      })
    },

    selAll() {
      this.flag = this.$refs.tableData.selection.length > 0
    },
    selChange() {
      this.flag = this.$refs.tableData.selection.length > 0
    },

    pageSizeChange(size){
      this.pageSize = size;
      this.pageChange(1);
    },

    pageChange(current) {
      this.curPage = current
      this.loadData()
    },
    pagePrev(current) {
      this.curPage = current
    },
    pageNext(current) {
      this.curPage = current
    },

    auditAll() {
      let selRows = this.$refs.tableData.selection
      let ids = []
      let totalMoney = 0
      selRows.forEach((element) => {
        ids.push(element.refundId)
        totalMoney += element.payAmount
      })
      this.$confirm("退款总" + selRows.length + "条记录，总金额<span class='money'>" + totalMoney + "</span>元，退款将从原路返回, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        dangerouslyUseHTMLString: true,
      }).then(() => {
        financeApi.audit(2, ids).then((res) => {
          if (res.code == 0) {
            this.$notify.success({
              title: "成功",
              message: res.msg,
            })
            this.loadData()
            this.getStat();
          } else {
            this.$notify.error({
              title: "错误",
              message: res.msg,
            })
          }
        })
      })
    },

    exportXLS() {
      let selRows = this.$refs.tableData.selection
      let ids = []
      selRows.forEach((element) => {
        ids.push(element.refundId)
      })

      financeApi.exportXLS(ids).then((res) => {
        if (res.type!='application/octet-stream') {
          this.$alert('下载失败', '错误', {
          confirmButtonText: '确定'});
        } else {
          attachUtil.download(res,"拒绝退款记录表.xls")
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
